import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { useEffect } from "react";
import { fetchStabilimenti } from "../../../features/stabilimenti/stabilimentiThunk";
import {
  selectStabilimenti,
  selectError,
  selectIsLoading,
} from "../../../features/stabilimenti/stabilimentiSlice";
import { CircularProgress, Box } from "@mui/material";
import { fetchCompanies } from "../../../features/company/companyThunk";

const SubStabilimenti = () => {
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const columns = [
    { field: "nomeStabilimento", headerName: "Nome stabilimento", width: 515 },
    { field: "tipologia", headerName: "Tipologia", width: 438 },
    { field: "supTotale", headerName: "Sup. Totale (m²)", width: 140 },
    { field: "supCoperta", headerName: "Sup. coperta (m²)", width: 158 },
    { field: "stoccaggio", headerName: "Stoccaggio L/t.", width: 140 },
    { field: "impianti", headerName: "Impianti", width: 132 },
    { field: "coordinateGPS", headerName: "Coordinate GPS", width: 160 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false },
  ];

  const dispatch = useDispatch();
  const stabilimenti = useSelector(selectStabilimenti) || [];
  const stabilimentiLoading = useSelector(selectIsLoading);
  const stabilimentiError = useSelector(selectError);

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  useEffect(() => {
    dispatch(fetchStabilimenti());
  }, [dispatch, selectSelectedCompany]);

  const mappedData = stabilimenti.map((item) => ({
    id: item?.id || "N/A",
    nomeStabilimento: item?.nome || "N/A",
    tipologia: item?.tipologia || "N/A",
    supTotale: item?.superficie_totale || "N/A",
    supCoperta: item?.superficie_coperta || "N/A",
    stoccaggio: item?.capacita_stoccaggio || "N/A",
    impianti: item?.presenza_impianti_speciali === true
    ? "true"
    : item?.presenza_impianti_speciali === false
    ? "false"
    : "N/A",
    coordinateGPS: item?.coordinate_gps || "N/A",
    azioni: item?.region || "N/A",
  }));

  return (
    <div className="pageTemplate">
      {stabilimentiLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="50vh"
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Table
          data={mappedData?.length ? mappedData : []}
          columns={columns}
          navData={"structureStabilimenti"}
          deleteFunctions={"deleteStabilimento"}
        />
      )}
    </div>
  );
};

export default SubStabilimenti;
